import { render, staticRenderFns } from "./suspension.vue?vue&type=template&id=ca464030&scoped=true"
import script from "./suspension.vue?vue&type=script&lang=js"
export * from "./suspension.vue?vue&type=script&lang=js"
import style0 from "./suspension.vue?vue&type=style&index=0&id=ca464030&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca464030",
  null
  
)

export default component.exports